import {forwardRef} from 'react';

import {SizeTokenValue} from 'common';

import {SVG} from './SVG';

import type {IconComponent} from '../types';

const largeIcon = (
  <path d="M16.0001 2H5.0001C3.9001 2 3.0001 2.9 3.0001 4V16H5.0001V4H16.0001V2ZM15.0001 6H9.0001C7.9001 6 7.0101 6.9 7.0101 8L7.0001 20C7.0001 21.1 7.8901 22 8.9901 22H19.0001C20.1001 22 21.0001 21.1 21.0001 20V12L15.0001 6ZM9.0001 20V8H14.0001V13H19.0001V20H9.0001Z" />
);

const smallIcon = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M4.505 3.06506C4.26476 3.06506 4.07 3.25981 4.07 3.50006V7.50006C4.07 7.8121 3.81704 8.06506 3.505 8.06506C3.19296 8.06506 2.94 7.8121 2.94 7.50006V3.50006C2.94 2.63573 3.64068 1.93506 4.505 1.93506H8.505C8.81704 1.93506 9.07 2.18802 9.07 2.50006C9.07 2.8121 8.81704 3.06506 8.505 3.06506H4.505ZM4.94 5.50006C4.94 4.63573 5.64068 3.93506 6.505 3.93506H9.505H10.0908C10.5059 3.93506 10.9039 4.09994 11.1974 4.39344L13.6116 6.80765C13.9051 7.10114 14.07 7.49921 14.07 7.91427V8.49901C14.07 8.49936 14.07 8.49971 14.07 8.50006C14.07 8.50041 14.07 8.50076 14.07 8.50111V12.5001C14.07 13.3644 13.3693 14.0651 12.505 14.0651H6.505C5.64068 14.0651 4.94 13.3644 4.94 12.5001V5.50006ZM12.94 7.93506V7.91427C12.94 7.7989 12.8942 7.68826 12.8126 7.60668L10.3984 5.19247C10.3168 5.11089 10.2062 5.06506 10.0908 5.06506H10.07V7.50006C10.07 7.7403 10.2648 7.93506 10.505 7.93506H12.94ZM8.94 5.06506V7.50006C8.94 8.36438 9.64068 9.06506 10.505 9.06506H12.94V12.5001C12.94 12.7403 12.7452 12.9351 12.505 12.9351H6.505C6.26476 12.9351 6.07 12.7403 6.07 12.5001V5.50006C6.07 5.25981 6.26476 5.06506 6.505 5.06506H8.94Z"
  />
);

export const CopyIcon: IconComponent = forwardRef((props, ref) => {
  const {size} = props;

  return (
    <SVG ref={ref} name="Copy" {...props}>
      {!size || size === SizeTokenValue.Large || size === SizeTokenValue.Medium ? largeIcon : smallIcon}
    </SVG>
  );
});
